import { swpBalanceSchedule, swpEndPeriod } from "../../engine/calculations";

const swpConfig = {
  key: "swp-income-from-corpus",
  title: "SWP (Income From Corpus)",
  category: "Retirement & Income",
  description: "See how long a corpus lasts if you draw a fixed monthly income from it.",
  fields: [
    { key: "corpus", label: "Corpus", type: "currency", default: 1_00_00_000, min: 1000, max: 50_00_00_000 },
    { key: "monthlyWithdrawal", label: "Monthly withdrawal", type: "currency", default: 60_000, min: 500, max: 50_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 7, min: 1, max: 20, assumptionKey: "debtReturn" },
  ],
  chart: {
    type: "line",
    xKey: "year",
    series: [{ key: "balance", label: "Remaining balance", colorVar: "--gold" }],
  },
  compute(values) {
    const corpus = Number(values.corpus) || 0;
    const monthlyWithdrawal = Number(values.monthlyWithdrawal) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;

    const endMonths = swpEndPeriod(corpus, monthlyWithdrawal, annualRate);
    const chartMonths = endMonths ? Math.min(endMonths, 40 * 12) : 30 * 12;
    const schedule = swpBalanceSchedule(corpus, monthlyWithdrawal, annualRate, chartMonths);

    const series = [];
    for (let m = 12; m <= chartMonths; m += 12) {
      series.push({ year: m / 12, balance: schedule[m - 1] });
    }

    return {
      headline: { label: "Corpus lasts", value: endMonths, format: "months" },
      breakdown: [
        { label: "Corpus", value: corpus },
        { label: "Monthly withdrawal", value: monthlyWithdrawal },
      ],
      series,
    };
  },
};

export default swpConfig;
